{{#each slides}}
  <div class='swiper-slide cases__slide'>
    {{#each this}}
      <div class='cases__item'>
        <img class='cases__img' src='{{imgUrl}}' alt='{{imgAlt}}' />
        <div class='cases__textContent'>
          <div class='cases__innerWrapper'>
            <h3 class='cases__subtitle subheading-3'>
              Objective
            </h3>
            <p class='body-2 cases__text cases__text--collapsed'>
              {{objective}}
            </p>
          </div>
          <div class='cases__innerWrapper'>
            <h3 class='cases__subtitle subheading-3'>
              Result
            </h3>
            <p class='body-2 cases__text cases__text--collapsed'>
              {{result}}
            </p>
          </div>
        </div>
        {{#if isShowMore}}
          <button class='cases__showMore-button' type='button'>
            Show More
          </button>
        {{/if}}
      </div>
    {{/each}}
  </div>
{{/each}}